import React from 'react'

import './Role.css'

class HistoryPanel extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="rolePanel">
                <div className="row">
                    <div className="col-md-12">
                        <div className="role-blk header">
                            <p className="role-blk-hdg">Role Permissions</p>

                            <table className="role table table-striped">
                                <thead>
                                    <tr className="head">
                                        <th>Roles</th>
                                        <th>Assigned</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>

                                <tbody>
                                {
                                    this.props.user.epIroles ?
                                        this.props.user.epIroles
                                            .filter(role => role.active)
                                            .map((role, index) => {
                                                return <tr key={index}>
                                                    <td>{role.roleName}</td>
                                                    <td>
                                                    {
                                                        this.props.user.userRoles.filter(userrole => userrole.roleId == role.roleId).length ?
                                                            <input type="checkbox" role={role.roleId}
                                                                defaultChecked={
                                                                    this.props.user.userRoles.filter(userrole => userrole.roleId == role.roleId)[0].assigned
                                                                }
                                                                onClick={this.props.onRoleUpdate}
                                                            />
                                                        :
                                                            <input type="checkbox" role={role.roleId} onClick={this.props.onRoleUpdate} />
                                                    }                                                   
                                                    </td>
                                                    <td>{role.roleDescription}</td>
                                                </tr>
                                        })
                                    : null
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default HistoryPanel